import {Injectable} from '@angular/core';
import {ListView,TypeComparaison,TypeFilter} from "@domain/common/list-view";
import {MessageAdmin,MessageAdminType} from "@domain/admin/bibliotheque/notification/message-admin";
import {AccueilItemComponent} from "@components/admin/bibliotheque/notifications/accueil/accueil-item/accueil-item.component";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {Sorting} from "@domain/common/list-view/sorting";

/**
 * Service de l'accueil
 *
 * @author Lionel Gimenez
 * @date 24/03/2026
 */
@Injectable()
export class AccueilService {
    /** Liste des messages admin */
    listeAccueilView: ListView<MessageAdmin, AccueilItemComponent>;

    /**
     * Constructeur
     *
     * @param translateService Service de traduction
     * @param router le routeur Angular
     */
    constructor(
        private translateService: TranslateService,
        private router: Router
    ) { }

    /**
     * Initialisation de la liste
     */
    initListView(): void {
        //Initialisation de la liste des messages admin
        this.listeAccueilView = new ListView<MessageAdmin, AccueilItemComponent>({
            uri: `/controller/MessageAdmin/loadListeMessage`,
            title: this.translateService.instant('admin.bibliotheque.notifications.accueil.title'),
            component: AccueilItemComponent,
            isFilter: true,
            defaultOrder: 'objet',
            extraOptions: {
                onSelect: this.select.bind(this)
            },
            listeFilters: [
                {
                    clef: 'objet',
                    title: this.translateService.instant('admin.bibliotheque.notifications.accueil.objet'),
                    isDefault: true,
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE]
                },
                {
                    clef: 'type',
                    title: this.translateService.instant('admin.bibliotheque.notifications.accueil.type'),
                    isDefault: true,
                    typeComparaison: TypeComparaison[TypeComparaison.IN],
                    listeValues: [
                        {code: '' + MessageAdminType.INFORMATION, libelle: this.translateService.instant('admin.bibliotheque.notifications.accueil.detail.typeOption.information')},
                        {code: '' + MessageAdminType.CONFIRMATION, libelle: this.translateService.instant('admin.bibliotheque.notifications.accueil.detail.typeOption.confirmation')},
                        {code: '' + MessageAdminType.AVERTISSEMENT, libelle: this.translateService.instant('admin.bibliotheque.notifications.accueil.detail.typeOption.avertissement')},
                        {code: '' + MessageAdminType.ALERTE, libelle: this.translateService.instant('admin.bibliotheque.notifications.accueil.detail.typeOption.alerte')}
                    ],
                    multiple: true
                },
                {
                    clef: 'isActif',
                    title: this.translateService.instant('admin.bibliotheque.notifications.accueil.actif'),
                    typeComparaison: TypeComparaison[TypeComparaison.EQUAL],
                    listeValues: [
                        {code: '' + true, libelle: this.translateService.instant('global.oui')},
                        {code: '' + false, libelle: this.translateService.instant('global.non')}
                    ]
                },
                {
                    clef: 'dateDebut',
                    title: this.translateService.instant('admin.bibliotheque.notifications.accueil.dateDebut'),
                    type: TypeFilter[TypeFilter.DATE]
                },
                {
                    clef: 'dateFin',
                    title: this.translateService.instant('admin.bibliotheque.notifications.accueil.dateFin'),
                    type: TypeFilter[TypeFilter.DATE]
                },{
                    clef: '#isAffiche',
                    title: this.translateService.instant('admin.bibliotheque.notifications.accueil.affiche'),
                    typeComparaison: TypeComparaison[TypeComparaison.EQUAL],
                    type: TypeFilter[TypeFilter.BOOLEAN]
                },
            ]
        });

        //Définition des colonnes de tri
        this.listeAccueilView.columns = [
            { key: 'objet', title: 'admin.bibliotheque.notifications.accueil.objet'},
            { key: 'type', title: 'admin.bibliotheque.notifications.accueil.type'},
            { key: 'dateDebut', title: 'admin.bibliotheque.notifications.accueil.dateDebut'},
            { key: 'dateFin', title: 'admin.bibliotheque.notifications.accueil.dateFin'}
        ];

        //Ajout du tri de la liste selon l'ordre voulu
        this.listeAccueilView.sorting = new Sorting(this.listeAccueilView.columns, "objet");

        //Persistence des filtres
        this.listeAccueilView.isPersistFilters = true;
        this.listeAccueilView.className = 'AccueilService';
    }

    /**
     * Méthode appelée à la sélection
     *
     * @param messageSelected Message sélectionné
     */
    select(messageSelected: MessageAdmin) {
        //Navigation vers les informations du message sélectionné
        this.router.navigate(['Admin/Bibliotheque/Notification/Accueil/' + messageSelected.idMessage]);
    }

    /**
     * Méthode appelée lors de la création
     */
    create() {
        //Navigation vers le formulaire de création d'un accueil
        this.router.navigate(['Admin/Bibliotheque/Notification/Accueil/0']);
    }
}
